import lodashGet from 'lodash/get';
import { SequenceHelper } from '@/api/commonModel';
import { inWindow, isElectron } from '@/config';
const isDev = () => inWindow() && ((window === null || window === void 0 ? void 0 : window.location.href.includes('su-desktop-web')) || (window === null || window === void 0 ? void 0 : window.location.href.includes('su-desktop-web.office.163.com')));
export class RenderChannel {
    constructor(params) {
        this.sequenceHelper = new SequenceHelper();
        this.promiseMap = new Map();
        this.eventMap = new Map();
        console.log('[web-channel]createChannel:', params);
        this.channelId = params.channelId;
        if (inWindow() && !isElectron()) {
            this.bindMessageEvent();
        }
    }
    getChannelId() {
        return this.channelId;
    }
    bindMessageEvent() {
        const { port1: sendPort, port2: receivePort } = new MessageChannel();
        this.myPort = sendPort;
        window.top.postMessage({
            type: 'createdPort',
            channelId: this.channelId,
        }, '*', [receivePort]);
        this.myPort.addEventListener('message', (args) => {
            const { data } = args;
            switch (data.channel) {
                case 'reply': {
                    const { ackno, code, msg, data: responseData } = data;
                    if (this.promiseMap.has(ackno)) {
                        const { resolve, reject } = this.promiseMap.get(ackno);
                        code === 0 ? resolve(responseData) : reject(msg);
                    }
                    break;
                }
                case 'event': {
                    if (this.eventMap.has(data.data.eventname)) {
                        [...this.eventMap.get(data.data.eventname).values()].forEach(callback => {
                            callback(data.data);
                        });
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        });
        this.myPort.start();
    }
    addResponseListener(callback) {
        var _a;
        (_a = this.myPort) === null || _a === void 0 ? void 0 : _a.addEventListener('message', (args) => {
            const { data } = args;
            if (data.channel !== 'response') {
                return;
            }
            callback(data.data);
        });
    }
    addEventListener(e, callback) {
        const eventId = [this.getChannelId(), e, this.sequenceHelper.next()].join('-');
        if (!this.eventMap.has(e)) {
            this.eventMap.set(e, new Map());
        }
        this.eventMap.get(e).set(eventId, callback);
        return eventId;
    }
    removeEventListener(e, eventId) {
        if (!e || !this.eventMap.has(e)) {
            return;
        }
        if (eventId && eventId.length) {
            this.eventMap.get(e).delete(eventId);
            return;
        }
        [...this.eventMap.get(e).keys()]
            .filter(eventname => eventname.indexOf(e) !== -1)
            .forEach(_id => {
            this.eventMap.delete(_id);
        });
    }
    async invoke(params) {
        const seqNo = [this.getChannelId(), this.sequenceHelper.next()].join('-');
        return new Promise((resolve, reject) => {
            this.promiseMap.set(seqNo, { resolve, reject });
            this.myPort.postMessage({
                channel: 'excute',
                seqno: seqNo,
                args: params,
                channelId: this.channelId,
            });
        });
    }
}
export class MainChannel {
    constructor() {
        this.ports = new Map();
        this.handleCallbackMap = new Map();
        if (!inWindow() || window.top !== window || isElectron()) {
            return;
        }
        window.onmessage = this.onCreatedPorts.bind(this);
    }
    registerHandleCallback(eventName, callback) {
        this.handleCallbackMap.set(eventName, callback);
    }
    broadcast(params, option = { selfChannelId: '', excludeSelf: false }) {
        const { selfChannelId, excludeSelf } = option;
        [...this.ports.keys()].forEach(_id => {
            if (_id === selfChannelId && excludeSelf) {
                return;
            }
            this.ports.get(_id).postMessage({
                channel: 'event',
                data: params,
            });
        });
    }
    onCreatedPorts(e) {
        if (lodashGet(e, 'data.type', '') !== 'createdPort') {
            return;
        }
        const { type, channelId } = e.data;
        console.log('[channel]createdport', type, channelId);
        const myPort = e.ports[0];
        this.ports.set(channelId, myPort);
        myPort.addEventListener('message', e => {
            this.onPortMessage(e, myPort);
        });
        myPort.start();
    }
    onPortMessage(e, port) {
        const { data: params } = e;
        if (lodashGet(params, 'channel', '') === '') {
            return;
        }
        switch (params.channel) {
            case 'excute': {
                const { seqno: ackNo } = e.data;
                this.handleRequest(e)
                    .then(data => {
                    this.reportResult({
                        error: null,
                        ackNo,
                        port,
                        data,
                        channelId: e.data.channelId,
                    });
                })
                    .catch(error => {
                    this.reportResult({
                        error,
                        ackNo,
                        port,
                        data: undefined,
                        channelId: e.data.channelId,
                    });
                });
                break;
            }
            default:
                break;
        }
    }
    handleRequest(e) {
        const { args } = e.data;
        const { eventName, params } = args;
        if (!this.handleCallbackMap.has(eventName)) {
            if (isDev()) {
                return Promise.resolve();
            }
            throw new Error('un-register-event:' + eventName);
        }
        const callback = this.handleCallbackMap.get(eventName);
        return callback(e, params);
    }
    reportResult(params) {
        const { error, data, ackNo, port } = params;
        port.postMessage({
            channel: 'reply',
            ackno: ackNo,
            code: error instanceof Error ? -1 : 0,
            msg: error instanceof Error ? error.message : 'ok',
            data,
        });
    }
    send2Render(portId, data) {
        if (!this.ports.has(portId)) {
            return;
        }
        const port = this.ports.get(portId);
        port.postMessage({
            channel: 'response',
            data,
        });
    }
}
